export default __webpack_public_path__ + "static/1341-5a450c2a8cf4e2dcea6ab1163f8e7d83.gif";